module.exports = __webpack_public_path__ + "a5cc05d041c2260d21f4e10282ff98b9.pdf";